import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MoveToFolderModal = ({ isOpen, onClose, folders, selectedForms, onMoveToFolder, forms }) => {
  const [selectedFolderId, setSelectedFolderId] = useState(null);

  if (!isOpen) return null;

  const handleMove = () => {
    onMoveToFolder(selectedForms, selectedFolderId);
    setSelectedFolderId(null);
    onClose();
  };

  const getFormTitles = () => {
    if (selectedForms?.length === 1) {
      const form = forms?.find(f => f?.id === selectedForms?.[0]);
      return form?.title || 'form';
    }
    return `${selectedForms?.length} forms`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-elevation-lg w-full max-w-md mx-4 p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground">Move to Folder</h3>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-smooth"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Move <span className="font-semibold text-foreground">{getFormTitles()}</span> to:
          </p>

          <div className="space-y-2 max-h-[300px] overflow-y-auto">
            {/* All Forms (Remove from folder) */}
            <button
              onClick={() => setSelectedFolderId(null)}
              className={`
                w-full flex items-center gap-3 px-4 py-3 rounded-md border transition-smooth
                ${selectedFolderId === null
                  ? 'border-primary bg-primary/5 text-primary' :'border-border hover:border-primary/50 hover:bg-muted'
                }
              `}
            >
              <Icon name="LayoutGrid" size={18} />
              <span className="flex-1 text-left text-sm font-medium">All Forms</span>
              {selectedFolderId === null && (
                <Icon name="Check" size={16} />
              )}
            </button>

            {/* Folders */}
            {folders?.map((folder) => (
              <button
                key={folder?.id}
                onClick={() => setSelectedFolderId(folder?.id)}
                className={`
                  w-full flex items-center gap-3 px-4 py-3 rounded-md border transition-smooth
                  ${selectedFolderId === folder?.id
                    ? 'border-primary bg-primary/5 text-primary' :'border-border hover:border-primary/50 hover:bg-muted'
                  }
                `}
              >
                <Icon name="Folder" size={18} />
                <span className="flex-1 text-left text-sm font-medium">{folder?.name}</span>
                {selectedFolderId === folder?.id && (
                  <Icon name="Check" size={16} />
                )}
              </button>
            ))}
          </div>

          {folders?.length === 0 && (
            <div className="text-center py-8">
              <Icon name="FolderOpen" size={32} className="mx-auto text-muted-foreground mb-2" />
              <p className="text-sm text-muted-foreground">No folders yet. Create one to organize your forms.</p>
            </div>
          )}

          <div className="flex items-center gap-2 justify-end pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={handleMove}
            >
              Move {selectedForms?.length > 1 ? 'Forms' : 'Form'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveToFolderModal;